import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  brandingStateLoading: false,
  brandingStateSuccess: false,
  brandingStateError: false,
  branding:"",
  brandingStateErrorMsg: "",
};

// _______________________createBrandingSettings response function and services calling
export const createBrandingSettings = createAsyncThunk(
  "createBrandingSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createBrandingSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const brandingSettingsSlice = createSlice({
  name: 'brandingSettings',
  initialState,
  reducers: {
    resetBrandingSettings: (state) => {
      state.brandingStateLoading = false;
      state.brandingStateSuccess = false;
      state.brandingStateError = false;
      state.brandingStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBrandingSettings.pending, (state) => {
        state.brandingStateLoading = true;
      })
      .addCase(createBrandingSettings.fulfilled, (state, action) => {
        state.brandingStateLoading = false;
        state.brandingStateSuccess = true;
        state.branding = action.payload;
      })
      .addCase(createBrandingSettings.rejected, (state, action) => {
        state.brandingStateLoading = false;
        state.brandingStateError = true;
        state.brandingStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetBrandingSettings } = brandingSettingsSlice.actions;
export default brandingSettingsSlice.reducer;